module.exports = __webpack_public_path__ + "static/img/14000686.3c64aac3.png";